"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsReducers = void 0;
var setElementsTotalCount = function (state, action) {
    state.elements.totalCount = action.payload.totalCount;
};
var setElementsTotalCountWithCurrentSettings = function (state, action) {
    state.elements.totalCountWithCurrentSettings = action.payload.totalCount;
};
var setOffset = function (state, action) {
    state.elements.currentOptions.offset = action.payload.offset;
};
var setSearch = function (state, action) {
    state.elements.currentOptions.search = action.payload.search;
};
var setOrder = function (state, action) {
    state.elements.currentOptions.order = action.payload.order;
};
var setLimit = function (state, action) {
    state.elements.currentOptions.limit = action.payload.limit;
};
var setLimitingAttributeFilters = function (state, action) {
    state.elements.currentOptions.limitingAttributeFilters = action.payload.filters;
};
var setLimitingAttributeFiltersAttributes = function (state, action) {
    state.elements.limitingAttributeFiltersAttributes = action.payload.attributes;
};
var setLimitingMeasures = function (state, action) {
    state.elements.currentOptions.limitingMeasures = action.payload.filters;
};
var setLimitingDateFilters = function (state, action) {
    state.elements.currentOptions.limitingDateFilters = action.payload.filters;
};
/**
 * @internal
 */
exports.elementsReducers = {
    setElementsTotalCount: setElementsTotalCount,
    setElementsTotalCountWithCurrentSettings: setElementsTotalCountWithCurrentSettings,
    setOffset: setOffset,
    setLimit: setLimit,
    setSearch: setSearch,
    setOrder: setOrder,
    setLimitingAttributeFilters: setLimitingAttributeFilters,
    setLimitingMeasures: setLimitingMeasures,
    setLimitingDateFilters: setLimitingDateFilters,
    setLimitingAttributeFiltersAttributes: setLimitingAttributeFiltersAttributes,
};
//# sourceMappingURL=elementsReducers.js.map